/**
 * Vite env validation at startup (R-18.58 / R-18.227): parse `import.meta.env` with
 * Zod and fail fast on missing/invalid values rather than discovering a bad config at
 * the first network call. Only VITE_-prefixed vars are exposed to the browser
 * (R-18.53); none of them are secrets (R-18.56).
 */

import { z } from 'zod';

const envSchema = z.object({
  VITE_API_BASE_URL: z.string().min(1).default('/api/v1'),
});

export const env = envSchema.parse(import.meta.env);
